<template>
  <div>
    <ProductAddToCartModal
      v-if="showCartModal"
      :buttons="buttons"
      :title="title"
      :quantity="quantity"
      :source = "source"
      :skucode ="skucode"
      :skuId ="skuId"
      :producttitle ="producttitle"
      :productimage = "productimage"
      :productimagealt = "productimagealt"
      :pricetext ="pricetext"
      :msrptext ="msrptext"
    />
    <ProductMessageModal
      v-else
      :buttons="buttons"
      :title="title"
      :message="message"
    />
  </div>
</template>

<script>
import ProductAddToCartModal from "./ProductAddToCartModal";
import ProductMessageModal from "./ProductMessageModal";

export default {
  props: {
    showCartModal: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array
    },
    quantity: {
      type: Number,
      default: 1
    },
    title: {
      type: String
    },
    message: {
      type: String
    },
    source: {
      type: String
    },
    skucode: {
      type: String
    },
    skuId: {
      type: String
    },
     producttitle: {
      type: String
    },
    productimage : {
      type: String
    },
    productimagealt : {
      type: String
    },
    msrptext: {
      type: String
    },
    pricetext: {
      type: String
    }
  },
  components: {
    ProductAddToCartModal,
    ProductMessageModal
  }
};
</script>

<style lang="scss">
#modals-container {
  .v--modal {
    box-shadow: none;
    background-color: transparent;
    padding: 20px;
    &-overlay {
      background: rgba(0, 0, 0, 0.4);
      z-index: 1001;
      overflow-y: scroll;
    }
  }
}
</style>
